import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'
import Select from 'react-select';
import Popup from './../popup/reactjs-popup.cjs.development';
import 'reactjs-popup/dist/index.css';
import { FormattedMessage, injectIntl } from 'react-intl';

export const ConfigServices = injectIntl(class extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      service: null,
      newService: null,
      services: [],
      companyServices: [],
      categories: [],
      loading: true,
      errorDeletion: "",
      companyId: parseInt(this.props.match.params.companyId) || 0
    };
    this.handleNew = this.handleNew.bind(this);
  }

  async componentDidMount() {
    await this.populateCategoriesData();
    this.populateCompaniesData();
  }

  selectService(service, addNew) {
    var companyServices = this.state.companyServices;
    var cs = companyServices.filter(s => s.id === service.id);
    if (cs.length > 0) {
      service = cs[0];
    }
    if (!addNew && cs.length === 0) {
      this.setState(prevState => ({...prevState, newService: service, service: null}));
      return;
    }
    if (service.maxTime === undefined)
      service.maxTime = 8760;
    if (service.timeEditable === undefined)
      service.timeEditable = true;
    this.setState(prevState => ({...prevState, newService: null, service: service}));
  }

  handleNew() {
    this.setState(prevState => ({...prevState, newService: { id: 0, categoryId: this.state.categoryId }}));
  }

  async handleSave(service) {
    if (!service.name || service.name === '')
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/service`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(service)
    });
    const data = await response.json();
    var companyServices = this.state.companyServices;
    for (var i = 0; i < companyServices.length; i++)
    {
      if (companyServices[i].id === service.id)
      {
        companyServices[i] = service;
        break;
      }
    }
    if (i === companyServices.length) {
      companyServices.push(data);
    }
    this.setState(prevState => ({...prevState, companyServices: companyServices}));
    this.selectService(data);
  }

  async handleCreate(newService) {
    if (!newService.name || newService.name === '')
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/service`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newService)
    });
    const data = await response.json();
    var companyServices = this.state.companyServices;
    companyServices.push(data);
    this.state.services.push({id: data.id, name: data.name});
    this.setState(prevState => ({...prevState, companyServices: companyServices}));
    this.selectService(data);
  }

  changeTimeEditable(service) {
    service.timeEditable = !service.timeEditable;
    this.setState(prevState => ({...prevState, service: service}));
    this.handleSave(service);
  }

  async handleDelete(id) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/service/${id}`, {
      method: "DELETE",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
    if (!response.ok) {
      this.setState(prevState => ({...prevState, errorDeletion: this.props.intl.formatMessage({id: "service_delete_failed"})}));
      return;
    }
    var companyServices = this.state.companyServices.filter(d => d.id !== id);
    if (this.state.service?.id === id)
      this.setState(prevState => ({...prevState, service: null}));
    this.setState(prevState => ({...prevState, companyServices: companyServices, errorDeletion: ""}));
  }

  selectCategory(category) {
    this.setState(prevState => ({...prevState, categoryId: category.value, selectedCategory: category}));
    this.populateServicesData(category.value);
  }

  renderServicesTable() {
    return (
      <>
    </>);
  }

  renderDelete(serviceId) {
    return (
      <>
      <p style={{color: "red"}}>{this.state.errorDeletion}</p>
      <div class="btndelete" onClick={() => this.handleDelete(serviceId)}><FormattedMessage id="confirm_deletion"/></div>
      </>
    );
  }

  renderAddService() {
    return (
      <>
        <div><FormattedMessage id="all_services"/></div>
          <label for="category"><FormattedMessage id="category"/></label>
          <Select
              className="formselect"
              classNamePrefix="select"
              isDisabled={false}
              isClearable={false}
              isSearchable={true}
              options={this.state.categories.filter(c => !c.parentCategoryId).map(c => ({ value: c.id, label: c.name }))}
              placeholder={this.props.intl.formatMessage({id: "search_categories"})}
              noOptionsMessage={() => this.props.intl.formatMessage({id: "no_results"})}
              onChange={(newValue) => this.selectCategory(newValue)}
              value={this.state.selectedCategory}
              name="category"
            />
      <div class="tabledivbig">
        <div class="tabledivbtn">

        <table className='table table-striped' aria-labelledby="tabelLabel">
          <thead>
            <tr>
              <th><FormattedMessage id="name"/></th>
            </tr>
          </thead>
          <tbody>
            {this.state.services.map(service =>
              <tr key={service.id} onClick={() => this.selectService(service, false)} class={this.state.service?.id === service.id || this.state.newService?.id === service.id?'react-calendar__tile--active':''}>
                <td>{service.name}</td>
              </tr>
            )}
          </tbody>
        </table>

        </div>
        <input style={{marginTop: "5px"}} disabled={this.state.newService?.id === 0} class="btn btn-primary" type="button" value={this.props.intl.formatMessage({id: "new"})} id="Button_New" onClick={this.handleNew}/>
        <input style={{marginTop: "5px"}} disabled={(!this.state.service && !this.state.newService) || this.state.newService?.id === 0 || this.state.companyServices.filter(s => s.id === this.state.service?.id).length !== 0} class="btn btn-primary" type="button" value={this.props.intl.formatMessage({id: "use_selected"})} id="Button_New" onClick={() => this.selectService(this.state.newService, true)}/>
      </div>

      {this.state.newService?.id === 0 ? <>
      <div class="form-group">
          <label for="Input_NewServiceName"><FormattedMessage id="service_name"/></label>
          <input class="form-control" type="text" id="Input_NewServiceName" name="Input.NewServiceName"
            value={this.state.newService.name ? this.state.newService.name : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, newService: {...prevState.newService, name: val}}));}}/>
        </div>
        <div class="form-group">
          <label for="Input_NewServiceCategory"><FormattedMessage id="category"/></label>
          <select class="form-control" id="Input_NewServiceCategory" name="Input.NewServiceCategory"
            value={this.state.newService.categoryId ? this.state.newService.categoryId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, newService: {...prevState.newService, categoryId: val}}));}}>
            {this.state.categories.map(category =>
              <option value={category.id}>{category.name}</option>
            )}
          </select>
        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" type="button" value={this.props.intl.formatMessage({id: "create"})} id="Button_Create" onClick={() => this.handleCreate(this.state.newService)}/>
        </> : <></>}
      </>
    );
  }

  renderCompanyServicesTable() {
    return (
      <div class="tablediv">

        <table className='table table-striped' aria-labelledby="tabelLabel">
          <thead>
            <tr>
              <th><FormattedMessage id="name"/></th>
              <th><FormattedMessage id="price"/></th>
              <th><FormattedMessage id="min_time"/></th>
              <th><FormattedMessage id="max_time"/></th>
              <th><FormattedMessage id="editable"/></th>
              <th><FormattedMessage id="delete"/></th>
            </tr>
          </thead>
          <tbody>
            {this.state.companyServices.map(service =>
              <tr key={service.id} onClick={() => this.selectService(service)} class={this.state.service?.id === service.id?'react-calendar__tile--active':''}>
                <td>{service.name}</td>
                <td>{service.price}</td>
                <td>{service.minTime}</td>
                <td>{service.maxTime}</td>
                <td onClick={() => this.changeTimeEditable(service)}>{service.timeEditable ? '+' : ''}</td>
                <Popup ref={this.selectorRef}
                  className="popup-book"
                  trigger={open => <td><FormattedMessage id="delete"/></td>}
                  position="bottom center"
                  closeOnDocumentClick>{() => this.renderDelete(service.id)}</Popup>
              </tr>
            )}
          </tbody>
        </table>

      </div>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em><FormattedMessage id="loading"/></em></p>
      : this.renderServicesTable();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="services" />
        <h4 id="tabelLabel"><FormattedMessage id="config_services"/></h4>
        {contents}
        <div><FormattedMessage id="company_services"/></div>
        <div class="configcolumns">
        <div class="leftpane">
        {this.renderCompanyServicesTable()}
        <Popup ref={this.selectorRef}
                  className="popup-book"
                  trigger={open => <input style={{marginBottom: "1rem"}} class="btn btn-primary" type="button" value="+" id="Button_Add"/>}
                  position="bottom center"
                  closeOnDocumentClick>{() => this.renderAddService()}</Popup>
        </div>


        {this.state.service === null?<></>:
        <div class="rightpane"><div class="form-group">
          <label for="Input_ServiceName"><FormattedMessage id="service_name"/></label>
          <input class="form-control" disabled={this.state.service.id} type="text" id="Input_ServiceName" name="Input.ServiceName"
            value={this.state.service.name ? this.state.service.name : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, name: val}}));}}/>
        </div>
        <div class="form-group">
          <label for="Input_ServiceCategory"><FormattedMessage id="category"/></label>
          <select class="form-control" disabled={this.state.service.id} id="Input_ServiceCategory" name="Input.ServiceCategory"
            value={this.state.service.categoryId ? this.state.service.categoryId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, categoryId: val}}));}}>
            {this.state.categories.map(category =>
              <option value={category.id}>{category.name}</option>
            )}
          </select>
        </div>
        <div class="form-group">
          <label for="Input_ServicePrice"><FormattedMessage id="service_price"/></label>
          <input class="form-control" type="text" id="Input_ServicePrice" name="Input.ServicePrice"
            value={this.state.service.price !== undefined ? this.state.service.price : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, price: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMinTime"><FormattedMessage id="service_min_duration"/></label>
          <input class="form-control" type="text" id="Input_ServiceMinTime" name="Input.ServiceMinTime"
            value={this.state.service.minTime !== undefined ? this.state.service.minTime : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, minTime: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMaxTime"><FormattedMessage id="service_max_duration"/></label>
          <input class="form-control" type="text" id="Input_ServiceMaxTime" name="Input.ServiceMaxTime"
            value={this.state.service.maxTime !== undefined ? this.state.service.maxTime : '8760'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, maxTime: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_BookingInterval"><FormattedMessage id="service_interval"/></label>
          <select class="form-control" id="Input_BookingInterval" name="Input.BookingInterval"
            value={this.state.service.bookingInterval ? this.state.service.bookingInterval.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, bookingInterval: val}}));}}>
              <option value="1"><FormattedMessage id="interval_min"/></option>
              <option value="2"><FormattedMessage id="interval_5min"/></option>
              <option value="3"><FormattedMessage id="interval_hour"/></option>
              <option value="4"><FormattedMessage id="interval_day"/></option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_PartialBooking"><FormattedMessage id="partial_booking"/></label>
          <select class="form-control" id="Input_PartialBooking" name="Input.PartialBooking"
            value={this.state.service.partialBooking ? this.state.service.partialBooking.toString() : 'null'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, partialBooking: val === 'null' ? null : val}}));}}>
              <option value="null"><FormattedMessage id="partial_off"/></option>
              <option value="2">2 <FormattedMessage id="partials_2_4_members"/></option>
              <option value="3">3 members</option>
              <option value="4">4 members</option>
              <option value="5">5 members</option>
              <option value="6">6 members</option>
              <option value="7">7 members</option>
              <option value="8">8 members</option>
              <option value="9">9 members</option>
              <option value="10">10 members</option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_CancelationHours"><FormattedMessage id="service_cancelation"/></label>
          <input class="form-control" type="text" id="Input_CancelationHours" name="Input.CancelationHours"
            value={this.state.service.cancelationHours !== undefined ? this.state.service.cancelationHours : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, cancelationHours: val.length > 0 ? val : null}}));}}
          />
        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" type="button" value={this.props.intl.formatMessage({id: "save"})} id="Button_Save" onClick={() => this.handleSave(this.state.service)}/>
        </div>}</div>
      </div>
    );
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
      const ownCompanies = this.state.companies.filter(c => this.state.companyId === 0 || c.id === this.state.companyId);
      if (ownCompanies.length > 0) {
        this.setState(prevState => ({...prevState, companyId: ownCompanies[0].id}));
        this.populateCompanyServicesData(ownCompanies[0].id);
      } else {
        window.location.replace(`/configcompany/${this.state.companyId}`);
      }
    }
  }

  async populateServicesData(categoryId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/services?categoryId=${categoryId}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, services: data, loading: false}));
  }

  async populateCategoriesData() {
    const token = await authService.getAccessToken();
    var url = `{{mainApiUrl}}api/services/categories/0`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, categories: data}));
  }

  async populateCompanyServicesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/services`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    if (data.length > 0 && !this.state.selectedCategory && this.state.categories.filter(c => c.id === data[0].categoryId).length > 0) {
      let category = this.state.categories.filter(c => c.id === data[0].categoryId)[0];
      if (category.parentCategoryId) {
        category = this.state.categories.filter(c => c.id === category.parentCategoryId)[0];
      }
      this.setState(prevState => ({...prevState, companyServices: data, loading: false, categoryId: category.id, selectedCategory: {value: category.id, label: category.name}}));
      this.populateServicesData(category.id);
    } else {
      this.setState(prevState => ({...prevState, companyServices: data, loading: false}));
    }
  }
})